import _ from 'lodash';
import {
    FETCH_RAINPRO_PICKERS,
    CLEAN_RAINPRO_PICKERS,
    CHANGE_RAINPRO_PICKER_EMAIL,
    CHANGE_RAINPRO_PICKER_SETTINGS,
} from './types';
import { request, __ } from '../functions';

export const fetchRainproPickers = (screen, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request('/rainpro/pickers', params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_RAINPRO_PICKERS, payload: data });
    });
};

export const changeRainproPickerEmail = (screen, id, email) => {
    const settings = {
        email_new: email,
    };

    return dispatch => request(`/rainpro/changeUserSettings/${id}`, { settings }, 'POST').then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmeniť email'));
            return;
        }

        screen.showSnackbar('success', __('Email bol zmenený'));

        dispatch({ type: CHANGE_RAINPRO_PICKER_EMAIL, payload: { id, email } });
    });
};

export const changeRainproPickerPassword = (screen, id, password, password_repeat) => {
    const settings = {
        password_new: password,
        password_new_repeat: password_repeat,
    };

    return dispatch => request(`/rainpro/changeUserSettings/${id}`, { settings }, 'POST').then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmeniť heslo'));
            return;
        }

        screen.showSnackbar('success', __('Heslo bolo zmenené'));
    });
};

export const changeRainproPickerSettings = (screen, id, settings, type = 'settings', reducerSettings = null) => {
    return dispatch => request(`/rainpro/setPickerSettings/${id}`, { settings }, 'POST').then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.onChangeSettings('loading', false);
            screen.showSnackbar('error', __('Nepodarilo sa uložiť nastavenia'));
            return;
        }

        screen.closeLightbox('settings');
        screen.showSnackbar('success', __('Nastavenia boli uložené'));

        if (reducerSettings !== null) {
            dispatch({ type: CHANGE_RAINPRO_PICKER_SETTINGS, payload: { id, settings: reducerSettings } });
            return;
        }

        dispatch({ type: CHANGE_RAINPRO_PICKER_SETTINGS, payload: { id, settings } });
    });
};

export const cleanRainproPickers = () => ({ type: CLEAN_RAINPRO_PICKERS });
